import {combineReducers} from 'redux';

import billPayerProfileReducer, {type ProfileState} from './bill-payer-profile/reducer';
import voucherModalState, {type VoucherModalState} from './bill-payer-profile/voucher-modal/reducer';

export interface BillPayerProfileState {
    profile: ProfileState;
    voucherModal: VoucherModalState;
}

export default combineReducers<BillPayerProfileState>({
    profile: billPayerProfileReducer,
    voucherModal: voucherModalState,
});
